var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.6677H2.33333C1.0856 18.7051 0.0424858 17.7266 0 16.4791V2.18857C0.042482 0.941179 1.0858 -0.0369288 2.33333 0.00107074H21C22.2475 -0.0369288 23.2909 0.941179 23.3333 2.18857V16.4802C23.2902 17.7273 22.2473 18.7051 21 18.6677Z",
    fill: "#c59d48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6857 12.5925C13.3364 12.8714 12.6962 13.2255 12.2298 13.1927C11.7684 13.1601 11.8567 12.7202 11.9482 12.3744L12.7213 9.45111C12.8101 9.11549 12.7621 8.75836 12.5879 8.45805C12.4138 8.15774 12.1276 7.93876 11.7922 7.84914C11.4568 7.75951 11.0996 7.80656 10.7988 7.97997C10.4981 8.15337 10.2784 8.43897 10.1879 8.77414C10.075 9.19218 9.17167 12.9203 9.1661 12.9436C9.03977 13.4733 8.88869 14.1503 9.1216 14.6724C9.47493 15.4643 10.548 15.2343 11.2 15.0458C11.6478 14.9182 12.0765 14.7309 12.4744 14.4891C12.9308 14.1778 13.3645 13.8346 13.7723 13.462L13.6857 12.5925Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.541 3.00301C11.5692 2.94209 10.6026 3.81573 10.5648 4.81685C10.553 5.11342 10.6297 5.4068 10.7853 5.65957C11.3886 6.63583 12.7748 6.42323 13.5242 5.74941C14.5133 4.86006 13.8508 3.08511 12.541 3.00301Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.eaa02de0ceb2ca500d747c1d7c3b96ce.svg";
export { ForwardRef as ReactComponent };